var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDraw(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#495057"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.354 14.5V5.74H9.622C10.19 5.74 10.678 5.848 11.086 6.064C11.502 6.28 11.822 6.584 12.046 6.976C12.278 7.368 12.394 7.832 12.394 8.368V11.86C12.394 12.396 12.278 12.864 12.046 13.264C11.822 13.656 11.502 13.96 11.086 14.176C10.678 14.392 10.19 14.5 9.622 14.5H7.354ZM8.434 13.54H9.622C10.15 13.54 10.562 13.392 10.858 13.096C11.162 12.8 11.314 12.388 11.314 11.86V8.368C11.314 7.848 11.162 7.44 10.858 7.144C10.562 6.848 10.15 6.7 9.622 6.7H8.434V13.54Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraw);
export default __webpack_public_path__ + "static/media/draw.b0271b6504f7eb04da7866da97552dc0.svg";
export { ForwardRef as ReactComponent };